const firebaseConfig = {
    apiKey: "AIzaSyB9xN_Ko6ywP29EqaHZGcvp6Edl8dxFAmo",
    authDomain: "gamenight-6deb8.firebaseapp.com",
    databaseURL: "https://gamenight-6deb8.firebaseio.com",
    projectId: "gamenight-6deb8",
    storageBucket: "gamenight-6deb8.appspot.com",
    messagingSenderId: "598727921825",
    appId: "1:598727921825:web:8cc349dff360369ce720e0",
    measurementId: "G-KCF464Z5SX"
  };

  module.exports = firebaseConfig